import { api } from '@/api/client';

/**
 * A floor-heating system as Odoo defines it. The roster is NOT maintained in the
 * frontend: the API reads it from the Odoo selection fields the portal writes to, so
 * a system added in Odoo Studio shows up in every dropdown here without a deploy.
 * See portal-api/src/utils/system-registry.ts.
 */
export interface SystemDef {
  /** Odoo selection value — what is stored on the record, e.g. "tacker". */
  code: string;
  /** Dutch display label, e.g. "Ultra-thin". */
  label: string;
  /** Tailwind background class for the system's colour dot. */
  dot: string;
  /** Selectable as a kring system. */
  kring: boolean;
  /** Selectable as a collector system (includes "meerdere systemen"). */
  collector: boolean;
  /** Has its own "Plaatsing onderaannemers" price rows per onderaannemer. */
  priced: boolean;
  /** Priced, or billed through another system (betonnet → staalnet): needs no typed €/m². */
  billingPriced: boolean;
}

export interface SystemsResponse {
  systems: SystemDef[];
  /** 'seed' means the API has not managed to read Odoo yet — the roster may lag. */
  source: 'seed' | 'odoo';
  refreshedAt: string | null;
}

export async function fetchSystems(): Promise<SystemsResponse> {
  return api<SystemsResponse>('/api/systems');
}
